const AIButton = ({ text, Icon = null, onClick }) => (
  <button type="default" className="ai-button" onClick={onClick}>
    {Icon && <Icon />}
    <span>{text}</span>
  </button>
);

export default AIButton